/**
 * @generated SignedSource<<141f8ff85c03178d64909c516188192d>>
 * @relayHash fab6ef1dd7d72059f57f0cdfaef3e535
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fab6ef1dd7d72059f57f0cdfaef3e535

import { ConcreteRequest } from 'relay-runtime';
export type De_signReferralLetterDocumentWithTelematikInfrastructureInput = {
  id: string;
};
export type useDeSignReferralLetterWithTelematikInfrastructureMutation$variables = {
  input: De_signReferralLetterDocumentWithTelematikInfrastructureInput;
};
export type useDeSignReferralLetterWithTelematikInfrastructureMutation$data = {
  readonly de_signReferralLetterDocumentWithTelematikInfrastructure: {
    readonly de_ReferralLetter: {
      readonly fileId: string | null;
      readonly id: string;
      readonly progressNoteId: string;
      readonly signedAt: string | null;
      readonly signedBy: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly errorType?: string;
      readonly message?: string;
    }> | null;
  };
};
export type useDeSignReferralLetterWithTelematikInfrastructureMutation = {
  response: useDeSignReferralLetterWithTelematikInfrastructureMutation$data;
  variables: useDeSignReferralLetterWithTelematikInfrastructureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_signReferralLetterDocumentWithTelematikInfrastructurePayload",
    "kind": "LinkedField",
    "name": "de_signReferralLetterDocumentWithTelematikInfrastructure",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_ReferralLetter",
        "kind": "LinkedField",
        "name": "de_ReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorType",
                "storageKey": null
              }
            ],
            "type": "SignDocumentMutationFailed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeSignReferralLetterWithTelematikInfrastructureMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeSignReferralLetterWithTelematikInfrastructureMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "fab6ef1dd7d72059f57f0cdfaef3e535",
    "metadata": {},
    "name": "useDeSignReferralLetterWithTelematikInfrastructureMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3cbf400b49dfb85cdd7130b9dc1344b2";

export default node;
